export const baseEvent = {
  context: 'TASK',
} as const

export enum BaseEventTypes {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  UPDATED = 'UPDATED',
}
